/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dirty_Stock_Jan_CareInputs */

const es_dirty_stock_jan_care = /** @type {(inputs: Dirty_Stock_Jan_CareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/día`)
};

const gl_dirty_stock_jan_care = /** @type {(inputs: Dirty_Stock_Jan_CareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/día`)
};

const en_dirty_stock_jan_care = /** @type {(inputs: Dirty_Stock_Jan_CareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/day`)
};

/**
* | output |
* | --- |
* | "/day" |
*
* @param {Dirty_Stock_Jan_CareInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const dirty_stock_jan_care = /** @type {((inputs?: Dirty_Stock_Jan_CareInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dirty_Stock_Jan_CareInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_dirty_stock_jan_care(inputs)
	if (locale === "en") return en_dirty_stock_jan_care(inputs)
	return es_dirty_stock_jan_care(inputs)
});